// Featured campus placements shown on the home "Building Careers" section.
// Image-led: each entry = a placed student (studio photo, white background) +
// the recruiting company's logo. Branch is decoded from the roll number.
// NOTE: filenames are case-sensitive on the Linux server — keep exact casing.
// No package/LPA is shown by design.
const DIR = "/images/home/placement_images";

export const featuredPlacements = [
  {
    name: "Kandula Krishna Reddy",
    branch: "CSE · AI & ML",
    company: "Lavendel Consulting",
    photo: `${DIR}/1nc22ci023-Lavendel.png`,
    logo: `${DIR}/Lavendel.png`,
    portrait: true, // source is 595×979 (already portrait)
  },
  {
    name: "Asiruddin Sayed",
    branch: "ECE",
    company: "O9 Solutions",
    photo: `${DIR}/1nc22ec094-O9.png`,
    logo: `${DIR}/o9-solutions-inc-vector-logo.png`,
  },
  {
    name: "Veghana N Gowda",
    branch: "CSE · Data Science",
    company: "Mphasis",
    photo: `${DIR}/1nc22cd058-Mphasis.png`,
    logo: `${DIR}/Mphasis.png`,
  },
  {
    name: "Kavana S",
    branch: "CSE",
    company: "LTIMindtree",
    photo: `${DIR}/1nc22cs074-LTIMindsTree.png`,
    logo: `${DIR}/LTIMindtree_Logo.svg.png`,
  },
  {
    name: "Tamanna HS",
    branch: "CSE",
    company: "Deloitte",
    photo: `${DIR}/1nc22cs167-Deloitte.png`,
    logo: `${DIR}/Deloitte.png`,
  },
];

export default featuredPlacements;
